import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axiosInstance from '../common/axios';
import discountService from '../service/discountService'; 

const DiscountManager = () => {
  const [discounts, setDiscounts] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingDiscount, setEditingDiscount] = useState(null);

  const [form, setForm] = useState({
    discountId: null,
    name: "",
    percentage: "",
    amount: "",
    startDate: null,
    endDate: null,
    type: "PERCENTAGE",
  });

  // Load discounts
  useEffect(() => {
    fetchDiscounts();
  }, []);

  const fetchDiscounts = async () => {
    try {
      const res = await discountService.fetchDiscount();// axiosInstance.get("/discounts");
      setDiscounts(res);
    } catch (err) {
      console.error("Error fetching discounts:", err);
    }
  };

  const handleOpen = (discount = null) => {
    setEditingDiscount(discount);
    if (discount) {
      setForm({
        discountId: discount.discountId,
        name: discount.name,
        percentage: discount.percentage,
        amount: discount.amount,
        startDate: discount.startDate,
        endDate: discount.endDate,
        type: discount.type,
      });
    } else {
      setForm({
        discountId: null,
        name: "",
        percentage: "",
        amount: "",
        startDate: null,
        endDate: null,
        type: "PERCENTAGE",
      });
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditingDiscount(null);
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    try {
    
      
           if (
    !form.name ||
    !form.startDate ||
    !form.endDate ||
    !form.type
  ) {
    alert("Please fill in all required fields.");
    return;
  }
      
      if(form.type==="PERCENTAGE"){
        
        if(!form.percentage){
              alert("Please fill in percentage required fields.");
              return;
        }
        
        form.amount= "";
        
      }else if(form.type==="FIXED_AMOUNT"){
        
        if(!form.amount){
          alert("Please fill in amount required fields.");
          return;
        }
         form.percentage= "";
      }
      
      
      if (form.discountId) {
        await discountService.updateDiscount(form.discountId,form); // axiosInstance.put(`/discounts/${form.id}`, form);
      } else {
        await discountService.saveDiscount(form); //axiosInstance.post("/discounts", form);
      }
      fetchDiscounts();
      handleClose();
    } catch (err) {
      console.error("Error saving discount:", err);
    }
  };

  const handleDelete = async (id) => {
    
     if (window.confirm("Are you sure you want to delete this discount?")) {
    try {
      await  discountService.deleteDiscount(id); // axiosInstance.delete(`/discounts/${id}`);
      fetchDiscounts();
    } catch (err) {
      console.error("Error deleting discount:", err);
    }
     }
  };

  const columns = [
    { field: "discountId", headerName: "ID", width: 70 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "percentage", headerName: "Percentage", flex: 1 },
    { field: "amount", headerName: "Amount", flex: 1 },
    { field: "startDate", headerName: "Start Date", flex: 1 },
    { field: "endDate", headerName: "End Date", flex: 1 },
    { field: "type", headerName: "Type", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (params) => (
        <>
          <Button onClick={() => handleOpen(params.row)}>Edit</Button>
          <Button color="error" onClick={() => handleDelete(params.row.discountId)}>
            Delete
          </Button>
        </>
      ),
      flex: 1,
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2>Discount Manager</h2>
      <Button variant="contained" onClick={() => handleOpen()}>
        Add Discount
      </Button>

      <div style={{ height: 400, marginTop: 20 }}>
        <DataGrid rows={discounts} columns={columns} pageSize={5} getRowId={(row) => row.discountId} />
      </div>

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>
          {editingDiscount ? "Edit Discount" : "Add Discount"}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Name"
            value={form.name}
            onChange={(e) => handleChange("name", e.target.value)}
            required
          />

          <TextField
            fullWidth
            margin="dense"
            label="Percentage"
            type="number"
            value={form.percentage}
            onChange={(e) => handleChange("percentage", e.target.value)}
            required
          />

          <TextField
            fullWidth
            margin="dense"
            label="Amount"
            type="number"
            value={form.amount}
            onChange={(e) => handleChange("amount", e.target.value)}
            required
          />
          <TextField
            margin="dense"
            label="Start Date"
            name="startDate"
            type="datetime-local"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.startDate}
           onChange={(e) => handleChange("startDate", e.target.value)}
           required
          />
          <TextField
            margin="dense"
            label="End Date"
            name="endDate"
            type="datetime-local"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.endDate}
            onChange={(e) => handleChange("endDate", e.target.value)}
            required
          />
          <TextField
            select
            fullWidth
            margin="dense"
            label="Type"
            value={form.type}
            onChange={(e) => handleChange("type", e.target.value)}
            required
          >
            <MenuItem value="PERCENTAGE">PERCENTAGE</MenuItem>
            <MenuItem value="FIXED_AMOUNT">FIXED AMOUNT</MenuItem>
          </TextField>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DiscountManager;
